<template>
    <div class="container">
        <b-container fluid v-show="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-show="showPage" style="margin-top:100px;">
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>eMGE ID: {{this.mgeId}}</h3>
                </b-col>
            </b-row>            
            <b-row>
                <b-col align-self="center">
                    <hr>                    
                </b-col>
            </b-row>
            <b-row>
                <b-col v-show="showMap">
                    <div id="chartdiv" style="height:25em"></div>
                </b-col>
                <b-col v-show="showPie">
                    <Plotly v-if="showDPie" :data="diseasePie" :layout="dPieLayout" :autoResize="true"></Plotly>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h4 >eMGE metadata
                        <a align="left" style="color:black;text-decoration: none;cursor: pointer" v-on:click="showMeta = !showMeta">
                                &nbsp;
                                <span v-show="!showMeta">[+]</span>
                                <span v-show="showMeta">[-]</span>
                        </a>
                    </h4>
                </b-col>
            </b-row>
            <b-collapse v-model="showMeta">
            <b-row style="text-align: left;">
                <b-col>
                    <div id="boxBr">
                        <ul>
                            <li><b>eMGE ID:</b> {{this.mgeId}}</li>
                            <li><b>Length:</b>{{this.mgeInfo.contig_length}}</li>
                            <li><b>Type:</b> <span style="color:red;font-weight: bold;">{{this.mgeInfo.status}}</span></li>
                            <li><b>Structure:</b> <span style="color:red;font-weight: bold;">{{this.mgeInfo.structure}}</span></li>
                            <li><b>Genome quality:</b>&nbsp;{{this.mgeInfo.Genome_quality}}</li>
                            <li><b>Cluster ID:</b>&nbsp;<router-link v-show="mgeInfo.MGEs_cluster != 'singleton'" :to="{ path: '/viewcluster/'+mgeInfo.MGEs_cluster}" target="_blank">{{this.mgeInfo.MGEs_cluster}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link> <span v-show="mgeInfo.MGEs_cluster === 'singlet'">{{this.mgeInfo.MGEs_cluster}}</span></li>
                            <li><b>Host range:</b>&nbsp;<span style="color:red;font-weight: bold;">{{this.mgeInfo.host_range ? this.mgeInfo.host_range : 'NA'}}</span></li>
                            <li><b>Gene number</b>&nbsp;<span style="color:red;font-weight: bold;">{{this.mgeInfo.gene_number}}</span></li>
                            <li><b>Sample count</b>&nbsp;<span style="color:red;font-weight: bold;">{{this.mgeInfo.sample_count ? this.mgeInfo.sample_count : 0}}</span></li>
                            <li><b>Study count</b>&nbsp;<span style="color:red;font-weight: bold;">{{this.mgeInfo.study_count ? this.mgeInfo.study_count : 0}}</span></li>
                            <li><b>PPR phage value:</b>&nbsp;<span style="color:red;font-weight: bold;">{{this.mgeInfo.PPR_phage_score}}</span></li>
                            <li><b>PPR plasmid value:</b>&nbsp;<span style="color:red;font-weight: bold;">{{this.mgeInfo.PPR_plasmid_score}}</span></li>
                            <li><b>Virfinder score:</b>&nbsp;<span style="color:red;font-weight: bold;">{{this.mgeInfo.Virfinder_score}}</span></li>
                            <li><b>GC content</b>&nbsp;<span style="color:red;font-weight: bold;">{{this.mgeInfo.GC_content}}</span></li>
                        </ul>
                    </div>
                </b-col>
            </b-row>
            </b-collapse>
            <b-row>
                <b-col align-self="center">
                    <hr>                    
                </b-col>
            </b-row>            
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h4 >Associated Runs
                        <a align="left" style="color:black;text-decoration: none;cursor: pointer" v-on:click="showSam = !showSam">
                                &nbsp;
                                <span v-show="!showSam">[+]</span>
                                <span v-show="showSam">[-]</span>
                        </a>&nbsp;
                        <span v-if="runStatus.length>1">{{runStatus}}</span>
                    </h4>
                </b-col>
            </b-row>
            <b-collapse v-model="showSam">
            <b-row style="text-align: left;">
                <b-col>
                    <b-row style="text-align: left;">
                        <b-col>
                            <hr>
                            <p><download-csv
                                    :data   = "sam_data" style="cursor: pointer;">
                                To download the Sample data for this eMGEs <span style="color:red;font-weight: bold;"> {{mgeId}} </span> in CSV format: &nbsp;
                                <font-awesome-icon icon="download" ></font-awesome-icon>
                                </download-csv></p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="sPerPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                        </b-col>
                        <b-col>
                            <b-col style="align:right">                       
                                <b-input-group>
                                    <b-form-input
                                    v-model="sFilter"
                                    type="search"
                                    placeholder="Type to Search"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!sFilter" @click="sFilter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-col>
                    </b-row>
                    <b-table
                        responsive
                        show-empty
                        :busy.sync="samIsBusy"
                        :striped="false"
                        :outlined="true"
                        :items="sam_data"
                        :fields="sam_fields"
                        :current-page="sCurrentPage"
                        :per-page="sPerPage"
                        :filter="sFilter"
                        @filtered="onFilteredS"
                    >
                        <template  v-slot:table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                      </div>
                            </template>
                        <template v-slot:cell(NCBI_Run_ID) ="row">
                                <router-link :to="{ path: '/viewsample/'+row.item.NCBI_Run_ID.trim()}" target="_blank" v-b-tooltip.hover title="View Project details in our database">{{row.item.NCBI_Run_ID.trim()}} <font-awesome-icon icon="link" size='sm'></font-awesome-icon></router-link>
                                <b-badge id="badge-tar" variant="primary"><a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.NCBI_Run_ID.trim()" target="_blank" style="color:white">NCBI <font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a></b-badge>
                        </template>
                        <template v-slot:cell(ProjectID) ="row">
                                <router-link :to="{ path: '/viewproject/'+row.item.ProjectID.trim()}" target="_blank" v-b-tooltip.hover title="View Project details in our database">{{row.item.ProjectID.trim()}} <font-awesome-icon icon="link" size='sm'></font-awesome-icon></router-link>
                                <b-badge id="badge-tar" variant="primary"><a v-bind:href="'https://www.ncbi.nlm.nih.gov/bioproject/' + row.item.NCBI_Run_ID.trim()" target="_blank" style="color:white">NCBI <font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a></b-badge>
                        </template>
                        <template v-slot:cell(Disease) ="row">
                            <span v-if="row.item.Disease.length >1">
                                <a v-bind:href="'https://www.ncbi.nlm.nih.gov/mesh/?term=' + row.item.Disease" target="_blank" >{{row.item.Disease}} <font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a>
                            </span>
                            <span v-else>
                                NA
                            </span>
                        </template>
                        <template v-slot:cell(HostAge) ="row">
                            <span v-if="row.item.HostAge.length >1">
                                {{row.item.HostAge}}
                            </span>
                            <span v-else>
                                NA
                            </span>
                        </template>
                        <template v-slot:cell(Sex) ="row">
                            <span v-if="row.item.Sex.length >1">
                                {{row.item.Sex}}
                            </span>
                            <span v-else>
                                NA
                            </span>
                        </template>
                        <template v-slot:cell(Phenotype) ="row">
                            <span v-if="row.item.Phenotype.length >1">
                                {{row.item.Phenotype}}
                            </span>
                            <span v-else>
                                NA
                            </span>
                        </template>
                        <template v-slot:cell(abundance) ="row">
                            <span v-if="row.item.abundance != null && row.item.abundance != 'NULL'">
                                    {{parseFloat(row.item.abundance).toFixed(4)}}
                                </span>
                                <span v-else>
                                    NA
                                </span>
                        </template>
                    </b-table>

                    <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="sCurrentPage"
                                :total-rows="totalSRows"
                                :per-page="sPerPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                    </b-row>
                </b-col>
            </b-row>
            </b-collapse>
            <b-row>
                <b-col align-self="center">
                    <hr>                    
                </b-col>
            </b-row>            
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h4 >Associated Host
                        <a align="left" style="color:black;text-decoration: none;cursor: pointer" v-on:click="showHost = !showHost">
                                &nbsp;
                                <span v-show="!showHost">[+]</span>
                                <span v-show="showHost">[-]</span>
                        </a>&nbsp;
                        <span v-if="hostStatus.length>1">{{hostStatus}}</span>
                    </h4>
                </b-col>
            </b-row>
            <b-collapse v-model="showHost">
            <b-row style="text-align: left;">                
                <b-col>
                    <b-row>
                        <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="hPerPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                        </b-col>
                        <b-col>
                            <b-col style="align:right">                       
                                <b-input-group>
                                    <b-form-input
                                    v-model="hFilter"
                                    type="search"
                                    placeholder="Type to Search"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!hFilter" @click="hFilter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-col>
                    </b-row>
                    <b-table
                        responsive
                        show-empty
                        :busy.sync="hostIsBusy"
                        :striped="false"
                        :outlined="true"
                        :items="host_data"
                        :fields="host_fields"
                        :current-page="hCurrentPage"
                        :per-page="hPerPage"
                        :filter="hFilter"
                        @filtered="onFilteredH"
                    >
                        <template  v-slot:table-busy>
                                        <div class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                        </div>
                        </template>
                        <template v-slot:cell(taxon_id)="row">
                            <a v-bind:href="'https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=' + row.item.taxon_id" target="_blank">{{row.item.taxon_id}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                        </template>
                    </b-table>
                    <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="hCurrentPage"
                                :total-rows="totalHRows"
                                :per-page="hPerPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                    </b-row>
                </b-col>
            </b-row>
            </b-collapse>
            <b-row>
                <b-col align-self="center">
                    <hr>                    
                </b-col>
            </b-row>            
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h4 >Associated Cluster
                        <a align="left" style="color:black;text-decoration: none;cursor: pointer" v-on:click="showClust = !showClust">
                                &nbsp;
                                <span v-show="!showClust">[+]</span>
                                <span v-show="showClust">[-]</span>
                        </a>&nbsp;
                        <span v-if="clusterStatus.length>1">{{clusterStatus}}</span>
                    </h4>
                </b-col>
            </b-row>
            <b-collapse v-model="showClust">
            <b-row style="text-align: left;">
                <b-col>                    
                    <b-row>
                        <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="cPerPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                        </b-col>
                        <b-col>
                            <b-col style="align:right">                       
                                <b-input-group>
                                    <b-form-input
                                    v-model="cFilter"
                                    type="search"
                                    placeholder="Type to Search"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!cFilter" @click="cFilter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-col>
                    </b-row>
                    <b-table
                        responsive
                        show-empty
                        :busy.sync="clustIsBusy"
                        :striped="false"
                        :outlined="true"
                        :items="clust_data"
                        :fields="clust_fields"
                        :current-page="cCurrentPage"
                        :per-page="cPerPage"
                        :filter="cFilter"
                        @filtered="onFilteredC"
                    >
                        <template  v-slot:table-busy>
                                        <div class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                        </div>
                        </template>
                        <template v-slot:cell(MGEs_cluster) ="row">
                                    <span v-if="row.item.MGEs_cluster != 'singlet'">
                                        <router-link :to="{ path: '/viewcluster/'+row.item.MGEs_cluster.trim()}" target="_blank">{{row.item.MGEs_cluster.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                                    </span>
                                    <span v-else>
                                        {{row.item.MGEs_cluster.trim()}}
                                    </span>
                        </template>
                        <template v-slot:cell(PC_id) ="row">
                                <router-link :to="{ path: '/viewprotcluster/'+row.item.PC_id}" target="_blank">{{row.item.PC_id}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                        </template>
                    </b-table>
                    <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="cCurrentPage"
                                :total-rows="totalCRows"
                                :per-page="cPerPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>                            
                    </b-row>
                </b-col>
            </b-row>
            </b-collapse>
            <br>
            <br>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
const _ = require("underscore")
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from '@amcharts/amcharts4-geodata/worldLow'
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import CountryMap from './CtryMap'

am4core.useTheme(am4themes_animated);
export default {
    data () {
        return{
            server_add:"https://mai.fudan.edu.cn/",
            showPage:false,
            showMap:false,
            showPie:false,
            filter:null,
            samIsBusy:true,
            sam_data:[],
            sam_fields:[
                { key:'NCBI_Run_ID',label:'NCBI Run ID',sortable:false },
                { key: 'ProjectID', label: 'Project ID', sortable: false },
                { key: 'BodySite', label: 'Site', sortable: true},
                { key: 'Country', label: 'Country', sortable: false},
                { key: 'HostAge', label: 'Age', sortable: true},
                { key: 'Sex', label: 'Sex', sortable: false},
                { key: 'Disease', label: 'Disease ID', sortable: false},
                { key: 'Phenotype', label: 'Phenotype', sortable: false},
                { key: 'IsViralDNAEnrichment', label: 'Viral enrichment', sortable: false},
                { key: 'abundance', label: 'Relative Abundance', sortable: false}, //
            ],
            totalSRows: 1,
            sCurrentPage: 1,
            sPerPage: 5,
            hostIsBusy:true,
            showDPie:false,
            diseasePie:[],
            dPieLayout:{
                title:'Phenotype distribution',
            },
            host_data:[],
            host_fields:[
                { key: 'taxon_id', label: 'Taxon ID', sortable: false},
                { key:'Taxon_domain',label:'Taxon domain',sortable:false },
                { key: 'Taxon_name', label: 'Name', sortable: false },
                { key: 'annotation_method', label: 'Annotation method', sortable: true},
            ],
            totalHRows: 1,
            hCurrentPage: 1,
            hPerPage: 5,
            clustIsBusy:true,
            clust_data:[],
            clust_fields:[
                { key: 'MGEs_cluster', label: 'eMGE cluster', sortable: false },
                { key: 'PC_id', label: 'Protein family ID', sortable: false},
                { key: 'function', label: 'Protein function', sortable: false },
            ],
            totalCRows: 1,
            cCurrentPage: 1,
            cPerPage: 5,
            pageOptions: [5, 10, 15,25],
            mgeId:'',
            mgeInfo:'',
            showMeta:false,
            showSam:false,
            showHost:false,
            showClust:false,
            sFilter:null,
            hFilter:null,
            cFilter:null,
            map:null,
            colorCache: {},
            hostStatus:'',
            clusterStatus:'',
            runStatus:'',
        }
    },
    mounted() {
        this.init()
        this.initMap()
    },
    methods: {
        init(){
            this.mgeId = this.$route.params.mgeid
            this.importMgeDet()
            this.importHostList()
            this.importClust()
        },
        initMap(){
            this.map = am4core.create("chartdiv", am4maps.MapChart);
            this.map.geodata = am4geodata_worldLow;
            this.map.projection = new am4maps.projections.Miller();
            this.map.zoomControl = new am4maps.ZoomControl();
            
            let title = this.map.titles.create();
            title.text = "eMGE habitat distriburion";
            title.fontSize = 19;
            title.marginBottom = 30;

            var button = this.map.chartContainer.createChild(am4core.Button);
            button.padding(5, 5, 5, 5);
            button.align = "right";
            button.marginRight = 15;
            var that = this
            button.events.on("hit", function() {
                that.map.goHome();
            });
            button.icon = new am4core.Sprite();
            button.icon.path = "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
        },
        importMgeDet(){
            axios.post(this.server_add+'query/getMgeInfo',
            {
                mgeId:this.mgeId
            }).then(retDat => {
                // console.log(retDat)
                if(retDat.status == 200 && Object.keys(retDat.data).length>1){
                    this.mgeInfo = retDat.data
                    this.showMeta = true
                    if(this.mgeInfo.sam_ids.length>1){
                        this.showPage = true
                        this.importSamStat()
                    }else{
                        this.runStatus = '0 sample runs found'
                        this.showPage = true
                    }
                }
            }).catch(err => {
                console.log(err)
            })
        },
        importHostList(){
            axios.post(this.server_add+'query/getHostLis',
            {
                mgeId:this.mgeId
            }).then(retDat => {
                if(retDat.status == 200){
                    this.host_data = retDat.data
                    this.totalHRows = this.host_data.length
                    this.hostIsBusy = false
                    this.showHost = true
                    if(this.totalHRows <=0){
                        this.showHost = false
                        this.hostStatus = '0 host are found'
                    }
                }
            }).catch(err => {
                console.log(err)
            })
        },
        importSamStat(){
            axios.post(this.server_add+'query/listMgeSam',
            {
                mgeid:this.mgeId,
                samids:this.mgeInfo.sam_ids
            }).then(retDat => {
                if(retDat.status == 200 && retDat.data != 'error:no mge found'){
                    this.sam_data = retDat.data
                    this.totalSRows = this.sam_data.length
                    this.showPage = true
                    if(this.totalSRows>=1){
                        this.showSam = true
                        this.genDiseasePlot()
                        this.loadMapCharts()
                    }
                    this.samIsBusy = false
                }else{
                    this.showPage = true
                    this.samIsBusy = false
                }
            }).catch(err => {
                console.log(err)
            })
        },
        importClust(){
            axios.post(this.server_add+'query/getMgeClust',
            {
                mgeid:this.mgeId
            }).then(retDat => {
                if(retDat.status == 200){
                    this.clust_data = retDat.data
                    this.totalCRows = this.clust_data.length
                    this.clustIsBusy = false
                    this.showPage = true
                    if(this.totalCRows >=1){
                        this.showClust = true
                    }else{
                        this.clusterStatus = '0 data found'
                    }
                }
            }).catch(err => {
                console.log(err)
            })
        },
        genDiseasePlot(){
            var grp = _.groupBy(this.sam_data,'Disease')
            var keyMap = Object.keys(grp).map(p=> {
                if(p == 'NA') return 'Unknown'
                else return p
                })
            var szMap = Object.values(grp).map(p=>p.length)
            var phenoAr = Object.values(grp).map(p=>p[0]['DiseaseName'])
            var total = szMap.reduce((a, b) => a + b)
            var text = szMap.map((v, i) => `${keyMap[i]}<br>${'Sample count:'+v}<br>${parseFloat(v / total * 100).toFixed(1)}%<br>${'Phenotype:'+phenoAr[i]}`)            
            this.diseasePie = [{
                type: "pie",
                values: szMap,
                labels: keyMap,
                textinfo: "label+percent",
                textposition: "outside",
                text:text,
                hoverinfo: 'text',
                automargin: true
            }]
            this.showDPie = true
            this.showPie = true
        },
        loadMapCharts(){
            var grp = _.groupBy(this.sam_data,'Country')
            var ctryMap = CountryMap.getCtryMap()
            var that = this
            var all_dat = []            
            Object.keys(grp).forEach(function(key) {
                var res = that.procCtryName(key,grp[key].length,ctryMap)
                if(res.length>=1){
                    all_dat.push.apply(all_dat,res)
                }
            });
            var polygonSeries = this.map.series.push(new am4maps.MapPolygonSeries());
            polygonSeries.data = all_dat
            var polygonTemplate = polygonSeries.mapPolygons.template;
            polygonTemplate.tooltipText = "{name}(Sample count:{value})";
            polygonTemplate.propertyFields.fill = "fill";
            polygonSeries.useGeodata = true;
            this.showMap = true
        },
        procCtryName(countryName,size,ctryMap){
            var sub = countryName.replace(' AND ',',').replace(' and ',',').replace(' OR ',',').replace(' or ',',').split(',')
            var ctrAr = []
            for(var ind in sub){
                var su = sub[ind]                
                if(ctryMap.has(su)){
                    ctrAr.push({'name':su,'id':ctryMap.get(su),'value':size,'fill':this.randomColor(ctryMap.get(su))})
                }else{
                    if(su.includes('United States of America')){
                        ctrAr.push({'name':'United States','id':'US','value':size,'fill':this.randomColor('US')})
                    }
                }
            }
            return ctrAr
        },
        randomColor(id) {
            const r = () => Math.floor(256 * Math.random());
            return this.colorCache[id] || (this.colorCache[id] = `rgb(${r()}, ${r()}, ${r()})`);
        },
        onFilteredS(filteredItems) {
            this.totalSRows = filteredItems.length
            this.sCurrentPage = 1
        },
        onFilteredH(filteredItems) {
            this.totalHRows = filteredItems.length
            this.hCurrentPage = 1
        },
        onFilteredC(filteredItems) {
            this.totalCRows = filteredItems.length
            this.cCurrentPage = 1
        },
    },
}
</script>

<style lang="less">
#boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 5px;
    align-content: left;
    color: black;
}

#boxBr{
    border-style: solid;
    margin-left: 20px;
    margin-top: 10px;
    border-width: 1px;
    padding: 0.5em;
    border-color:#F2F3F4;
}
</style>